import type { LessonListVM } from "@shared-kernel/application/ports/admin/admin-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrievePaymentLessonList = createApiThunk<LessonListVM, string>(
  "transfers/retrievePaymentLessonList",
  async (id: string, { extra: { adminRepository } }) => {
    return adminRepository!.listTransferLessons(id);
  },
);
